import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { TuiSizeL, TuiSizeM, TuiSizeS } from '@taiga-ui/core';
import { UserUI, ViewMode } from '@src/models';
import { UserService } from '@src/core/services';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-field-user',
  templateUrl: './field-user.component.html',
  styleUrls: ['./field-user.component.scss', '../styles/field-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldUserComponent implements OnChanges {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly userService = inject(UserService);

  @Input() mode?: ViewMode = 'view';
  @Input() name?: string;
  @Input() userId?: string | null;
  @Input() userFullName?: string;
  @Input() size: TuiSizeS | TuiSizeM | TuiSizeL = 'l';

  @Input() noUnderline?: boolean = false;

  user?: UserUI;

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.userId || changes.userFullName) {
      this.user = undefined;
      // TODO: refactoring.  Вынести компонент отображения поля с пользователей в отдельный модуль
      if (this.userFullName) {
        const userId = this.userId ?? undefined;
        this.user = { id: userId, fullName: this.userFullName };
      } else if (this.userId) {
        const users = await lastValueFrom(this.userService.getUsersData([this.userId]));
        if (users.length) {
          this.user = users[0];
        }
      }
    }

    this.cdr.markForCheck();
  }
}
